import React, { useContext, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import _routerService from "../services/_routerService";
import AppContext from "./context";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import IconButton from "@mui/material/IconButton";

export default function App({ match, history, location }) {
  const { titulo, intitular } = useContext(AppContext);

  useEffect(() => {
    const rotaAtual = location.pathname.split("/")[2];
    let titulo = "";

    if (rotaAtual)
      _routerService
        .filter((rota) => rota.path === rotaAtual)
        .forEach((rota) => (titulo = rota.title));

    intitular(titulo);

    document.title = titulo ? `${titulo} - Painel Escola` : "Painel Escola";
  }, [location.pathname]);

  return (
    <div style={{ marginTop: 30 }}>
      {titulo && (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <IconButton onClick={() => history.go(-1)} style={{ marginRight: 5 }}>
            <ChevronLeftIcon />
          </IconButton>
          <h2 style={{ marginTop: 5 }}>{titulo}</h2>
        </div>
      )}
      <Switch>
        {_routerService.map((route) => (
          <Route
            path={`${match.url}/${route.path}`}
            component={route.component}
            exact={route.exact}
          />
        ))}
      </Switch>
    </div>
  );
}
